import React, { Component } from 'react';
import { Spinner } from 'evergreen-ui';

export default class Loading extends Component {
    render() {
        return (
            <div>
                <Spinner />
            </div>
        );
    }
}